module.exports = __webpack_public_path__ + "static/c19-7fa4a6ea28ba4ce31e3087a398e1e8dd.jpg";